/**
 * 화면 5 · 이탈/취소 (CancelledScreen) — 디자인 원본 Pantalla 5.
 *
 * @see #781 / admin#2111 설계 §6.1
 */
import { Users } from 'lucide-react';
import { Button } from '@/components/ui/button';
import type { WaitlistStrings } from './strings';

interface WaitlistCancelledScreenProps {
  t: WaitlistStrings;
  onReset: () => void;
}

export function WaitlistCancelledScreen({ t, onReset }: WaitlistCancelledScreenProps) {
  return (
    <div className="flex flex-1 flex-col items-center justify-center overflow-y-auto px-7 py-10 text-center">
      <div className="mb-[22px] grid size-[84px] place-items-center rounded-full bg-background-secondary text-muted-foreground">
        <Users className="size-10" />
      </div>
      <h1 className="m-0 mb-2 text-2xl font-extrabold leading-tight">{t.salisteFila}</h1>
      <p className="m-0 mb-8 max-w-[300px] text-[15px] leading-relaxed text-muted-foreground">
        {t.liberamos}
      </p>
      <Button size="lg" className="w-full max-w-[300px]" onClick={onReset}>
        {t.volverUnirme}
      </Button>
    </div>
  );
}
